export function getToken() {
    return window.localStorage.getItem("token");
}

export function clearLoginState() {
    window.localStorage.removeItem("token");
    window.localStorage.removeItem("userId");
    window.localStorage.removeItem("adminuser");
}

export function isSuccessResponse(data) {
    return !!(data && data.message && Number(data.message.code) === 0);
}

export function isLoginExpiredResponse(data) {
    if (!data || !data.message) {
        return false;
    }
    return [201, 401, 403].includes(Number(data.message.code));
}
